export default "__VITE_ASSET__ca3d0cd9__"